import { sendGTMEvent } from '../analytics/gtm-helper';

export const trackStoreBtn = () => {
  sendGTMEvent({
    event: 'store_btn_clicked',
  });
};

export const setUserId = (userId: string) => {
  sendGTMEvent({
    userId: userId,
  });
};
